import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
  {
    path: '/login',
    name: 'login',    
    meta: {layout: 'empty'},
    component: () => import('../views/Login.vue')
  },  
  {
    path: '/register',
    name: 'register',    
    meta: {layout: 'empty'},
    component: () => import('../views/Register.vue')
  },


  {
    path: '/',
    name: 'home',    
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/Home.vue')
  },

  {
    path: '/course/course',
    name: 'course',
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/Course.vue')
  },

  {
    path: '/course/video',
    name: 'video',
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/Video.vue')
  },

  {
    path: '/course/mode',
    name: 'mode',
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/Mode.vue')
  },
  {
    path: '/course/mode_progress',
    name: 'mode_progress',
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/ModeProgress.vue')
  },
  {
    path: '/course/mode_satzes',
    name: 'mode_satzes',
    meta: {layout: 'main', auth: true},
    component: () => import ('../views/ModeSatzes.vue')
  },

  {
    path: '/profile',
    name: 'profile',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/Profile.vue')
  },  
    
 

  {
    path: '/grammatik/adjektiv',
    name: 'grammatik_adjektiv',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikAdjektiv.vue')
  }, 
  {
    path: '/grammatik/adverb',
    name: 'grammatik_adverb',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikAdverb.vue')
  }, 
  {
    path: '/grammatik/artikel',
    name: 'grammatik_artikel',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikArtikel.vue')
  }, 
  {
    path: '/grammatik/konjunktion',
    name: 'grammatik_konjunktion',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikKonjunktion.vue')
  }, 
  {
    path: '/grammatik/praeposition',
    name: 'grammatik_praeposition',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikPraeposition.vue')
  }, 
  {
    path: '/grammatik/pronomen',
    name: 'grammatik_pronomen',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikPronomen.vue')
  }, 
  {
    path: '/grammatik/satzbau',
    name: 'grammatik_satzbau',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikSatzbau.vue')
  },
  {
    path: '/grammatik/substantiv',
    name: 'grammatik_substantiv',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikSubstantiv.vue')
  },
  {
    path: '/grammatik/verbarten',
    name: 'grammatik_verbarten',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikVerbarten.vue')
  },
  {
    path: '/grammatik/verbzeiten',
    name: 'grammatik_verbzeiten',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikVerbzeiten.vue')
  },
  {
    path: '/grammatik/verbmodus',
    name: 'grammatik_verbmodus',    
    meta: {layout: 'main', auth: true},
    component: () => import('../views/grammatik/GrammatikVerbmodus.vue')
  },

]

})

router.beforeEach((to, from, next) => {
  const currentUser = store.getters.user;  
  const requireAuth = to.matched.some(record => record.meta.auth);

  if (requireAuth && !currentUser.id) {
    next('/login')
  } else {
    next()
  }
})


export default router
